import { FC } from "react";

import { Box } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import responsiveStyle from "@lib/theme/responsiveStyle";

import SectionTitle from "../common/SectionTitle";
import OrderInfoInvoice from "./orderInfoItems/OrderInfoInvoice";
import OrderInfoPackageSize from "./orderInfoItems/OrderInfoPackageSize";
import OrderInfoReceiver from "./orderInfoItems/OrderInfoReceiver";
import OrderInfoSender from "./orderInfoItems/OrderInfoSender";

const OrderInfo: FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box px={responsiveStyle({ mobile: "0", desktop: "2rem" })} py="1rem">
        <SectionTitle>{t("order-summary-parcel")}</SectionTitle>
      </Box>
      <Box
        borderTop="1px solid"
        borderBottom="1px solid"
        borderColor="grey.light"
        px={responsiveStyle({ mobile: "0", desktop: "2rem" })}
      >
        <Box>
          <OrderInfoPackageSize />
        </Box>
        <Box borderTop="1px solid" borderColor="grey.light">
          <OrderInfoSender />
        </Box>
        <Box borderTop="1px solid" borderColor="grey.light">
          <OrderInfoReceiver />
        </Box>
        <Box borderTop="1px solid" borderColor="grey.light">
          <OrderInfoInvoice />
        </Box>
      </Box>
    </Box>
  );
};
export default OrderInfo;
